module.exports = __webpack_public_path__ + "media/images/alto-2c01372bfddb777ab74a70cab904e05b.png";